/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.13 holo-puck.glb --transform 
Files: holo-puck.glb [1.17MB] > holo-puck-transformed.glb [253.22KB] (78%)
Author: thekaz.2128 (https://sketchfab.com/thekaz.2128)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/holo-puck-4b8be9e0e41d4611a99e9641ee0f83f0
Title: Holo-Puck
*/

import React, { useRef } from "react";
import { Plane, Sphere, useGLTF } from "@react-three/drei";

export default function HoloPuck(props) {
  const { nodes, materials } = useGLTF("/holo-puck-transformed.glb");

  materials.Material.envMapIntensity = 0.6;
  materials.Material.emissiveIntensity = 0.05;

  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes.Cylinder_Material_0.geometry}
        material={materials.Material}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={[2.972, 2.972, 0.396]}
        receiveShadow
      />
    </group>
  );
}

useGLTF.preload("/holo-puck-transformed.glb");
